export default __webpack_public_path__ + "images/gestational_age_blue.e86bdcf1c35c02925f2697bf5b02efd7.png";